<ng-container>
  @if (missingItems) {
    <div class="card mb-3">
      <div class="multi-vin-container">
        <div class="d-flex">
          <i class="allycon-error-fill text-destructive pe-2" aria-hidden="true"></i>
          <div aria-live="polite" aria-atomic="true" class="overflow-hidden">
            <strong>{{ translations.textCouldntFind }} {{ missingItems.length }} {{ type === multiSearchMode.VIN ? translations.textVIN : translations.textStockUnit }}{{ missingItems.length > 1 ? 's' : '' }}. {{ translations.textContactHelp }}</strong>
            <div class="vin-list">
              {{ missingItems.join(', ') }}
              <button allytmln='multiVinErrorShowMore' class="btn btn-link p-0"
                      (click)="showModal()">
                <span>
                  {{ translations.btnSeeMore }}
                </span>
              </button>
            </div>
          </div>
        </div>
        <button class="error__close" [attr.aria-label]="translations.btnCloseError" (click)="closeError()" data-track-elem="icon"
                data-track-name="Close" data-track-trigger="close">
          @if (configuration) {
            <img src="../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
                 alt="translations.altCloseErrorIcon" />
          }
        </button>
      </div>
    </div>
    <app-multi-vin-error-modal [vins]="missingItems"></app-multi-vin-error-modal>
  }
</ng-container>
